<template>
  <div>
    <div id="historyDraw111">
      <!-- <div id="historyDraw"></div> -->
    </div>

    <div style="padding: 10px 0 0 10px">
      图表放大比例：
      <RadioGroup v-model="baifenbi" @on-change="changeBai">
        <Radio :label="100">100%</Radio>
        <Radio :label="200">200%</Radio>
        <Radio :label="400">400%</Radio>
        <Radio :label="800">800%</Radio>
        <Radio :label="1600">1600%</Radio>
        <Radio :label="3200">3200%</Radio>
      </RadioGroup>
    </div>
  </div>
</template>
<script>
var chart;
export default {
  data() {
    return {
      no: true,
      baifenbi: 100,
      list1: [
        /* {
          value: ["2023-01-03 00:10:58", 12, "关", 0, 59.43],
        },
        {
          value: ["2023-01-03 01:10:58", -3, "关", 0, 59.43],
        },
        {
          value: ["2023-01-03 02:10:58", -7, "关", 0, 59.43],
        },
        {
          value: ["2023-01-03 03:10:58", 11, "关", 0, 59.43],
        }, */
      ],
      list2: [
        /* {
          value: ["2023-01-03 00:10:58", 5, "关", 0, 19.43],
        },
        {
          value: ["2023-01-03 01:10:58", -9, "关", 0, 19.43],
        },
        {
          value: ["2023-01-03 02:10:58", 2, "关", 0, 19.43],
        },
        {
          value: ["2023-01-03 03:10:58", 8, "关", 0, 19.43],
        }, */
      ],
      list3: [],
      list4: [],
    };
  },
  methods: {
    reData(list1, list2, list3, list4) {
      console.log(list1);
      this.list1 = list1;
      this.list2 = list2;
      this.list3 = list3;
      this.list4 = list4;
      var length = this.list1.length;
      /* if (length >= 0 && length < 600) {
        this.baifenbi = 100;
      } else if (length >= 600 && length < 1500) {
        this.baifenbi = 200;
      } else if (length >= 1500) {
        this.baifenbi = 400;
      } */
      this.draw();
    },
    draw() {
      var jiange = 24;
      if (this.baifenbi > 0 && this.baifenbi <= 400) {
        jiange = 24;
      } else if (this.baifenbi > 400 && this.baifenbi <= 1600) {
        jiange = 12;
      } else if (this.baifenbi > 1600 && this.baifenbi <= 3200) {
        jiange = 6;
      }
      document.getElementById("historyDraw111").innerHTML =
        '<div id="historyDraw" style="width:' + this.baifenbi + '%"></div>';
      setTimeout(() => {
        var tt = document.getElementById("historyDraw");
        chart = this.echarts.init(tt);
        this.option = {
          backgroundColor: "",
          /* title: {
              text: "温度-时间图像",
            }, */
          color: ["red", "#588fe2", "#5ee671", "#f5aee0"],
          grid: {
            x: 60,
            y: 60,
            x2: 100,
            y2: 50, //距离下边的距离
          },
          legend: {
            left: 100, //图例组件离右边的距离
            top: 30,
            // orient: "vertical", //布局  纵向布局
            orient: "horizontal", //布局  纵向布局
            width: 350, //图行例组件的宽度,默认自适应
            x: "right", //图例显示在右边
            itemWidth: 10, //图例标记的图形宽度
            itemHeight: 10, //图例标记的图形高度
            textStyle: {
              //图例文字的样式
              color: "#333",
              fontSize: 12,
            },
          },
          tooltip: {
            trigger: "axis",
            formatter(params) {
              
               return (
                '<div style="padding:6px;color:#fff">' +
                params[0].value[0] +
                /* "<br>相对里程：" +
                params[0].value[1] +
                "km" +
                "<br>绝对里程：" +
                params[0].value[2] +
                "km" +
                "<br>速度：" +
                params[1].value[1] +
                "km/h" +
                "<br>发动机：" +
                params[2].value[2] + */
                "</div>"
              );
 
            },
            axisPointer: {
              animation: false,
            },
          },
          /* dataZoom: [
              {
                type: "inside",
                //type: "slider",
                //yAxisIndex:[0],
                //xAxisIndex:[0],
                start: 0, //放大起点
                //end: this.end(list),
                end: 100, //放大终点
                //startValue:10,
                //zoomLock:true
              },
            ] ,*/
          xAxis: {
            type: "time",
            minInterval: 1,
            maxInterval: 3600 * jiange * 1000,
          },
          yAxis: [
            {
              type: "value",
              name: "相对里程",
              position: "left",
              alignTicks: true,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#333",
                },
              },
              axisLabel: {
                formatter: "{value} ",
              },
            },
            {
              type: "value",
              name: "速度",
              position: "right",
              offset: 60,
              alignTicks: true,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#333",
                },
              },
              axisLabel: {
                formatter: "{value} ",
              },
            },
            {
              type: "value",
              name: "发动机",
              position: "right",
              offset: 20,
              alignTicks: true,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#333",
                },
              },
              axisLabel: {
                formatter: "{value} ",
              },
            },
          ],
          series: [
            {
              name: "相对里程",
              type: "line",
              yAxisIndex: 0,
              data: this.list1,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
            },
            {
              name: "速度曲线",
              type: "line",
              yAxisIndex: 1,
              data: this.list2,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
            },
            {
              name: "发动机曲线",
              type: "bar",
              yAxisIndex: 2,
              data: this.list3,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
            },
          ],
        };
        chart.setOption(this.option, true); //true重绘
      }, 200);
    },
    changeBai(v) {
      this.draw();
    },
  },
  //调用
  mounted() {
    //this.drawBar("olinow");
    this.draw();
  },
  destroyed() {},
};
</script>
<style lang="">
#historyDraw111 {
  width: calc(100% - 20px);
  height: 400px;
  overflow: auto;
  background: #fff;
  margin: 0 10px;
}
#historyDraw {
  height: 380px;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/historyChart.vue